import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
import { SMALL_SCALE } from '../../BSLAConstants';

const BSLAGroundWaterContaminationLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/WRM_UIC_PUBLIC/MapServer/6',
        visible: false,
        title: 'Ground Water Contamination (FDEP)',
        minScale: SMALL_SCALE,
        popupTemplate: {
            outFields: ['*'],
            title: 'Ground Water Contamination (FDEP)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');
                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Zone ID" value={atts.ZONE_ID} />
                        <BSLAPopupItemComponent label="Contimnant Code" value={atts.CONTAMINANT_CODES} />
                        <BSLAPopupItemComponent label="Water Management District" value={atts.FLORIDA_WMDS} />
                        <div className="mt-1">{atts.COUNTY_NAME} County</div>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAGroundWaterContaminationLayer;
